var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userData)?[_c('b-row',[_c('b-col',{attrs:{"cols":"12","xl":"12","lg":"12","md":"12"}},[_c('user-view-user-info-card',{attrs:{"user-data":_vm.userData}})],1)],1)]:_vm._e(),_c('AccountSetting')],2)}
var staticRenderFns = []

export { render, staticRenderFns }